import React from "react";
import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../../redux/content";
import "../styles/uclSection.scss";

/**
 * UclSection — Reusable UEFA Champions League matches section
 * Figma: Football matches (24654:4824)
 * Used on: HomePage, DiscoveryPage
 *
 * Props:
 *   sportsChannels — array of Live channel objects from the "sports" category
 *                    Each: { id, uid, name, short_name, logos, image_stores }
 *                    Falls back to static UCL placeholders if empty/undefined.
 */

const UCL_FALLBACK_MATCHES = [
  { id: "barca-antwerp", img: "/assets/ucl/match-1.webp", league: "UEFA Champions League", title: "Barcelona vs Royal Antwerp  | Group Stage" },
  { id: "newcastle-psg", img: "/assets/ucl/match-2.webp", league: "UEFA Champions League", title: "Newcastle United vs Paris Saint Germain  | Group Stage" },
  { id: "bayern-manu", img: "/assets/ucl/match-3.webp", league: "UEFA Champions League", title: "FC Bayern vs Manchester United | Group Stage" },
  { id: "mancity-zvezda", img: "/assets/ucl/match-4.webp", league: "UEFA Champions League", title: "Manchester City vs Crvena Zvezda | Group Stage" },
  { id: "mancity-zvezda", img: "/assets/ucl/match-4.webp", league: "UEFA Champions League", title: "Manchester City vs Crvena Zvezda | Group Stage" },
];

const UclSection = ({ sportsChannels = [] }) => {
  const navigate = useNavigate();

  // Map API channels to card shape, fall back to static if none
  const matches = sportsChannels.length > 0
    ? sportsChannels.map((ch) => {
        const logoId =
          ch.logos?.NORMAL || ch.logos?.CARD ||
          (ch.image_stores?.find((s) => s.type === "NORMAL") || ch.image_stores?.[0])?.image_id;
        return {
          id: ch.uid || ch.id,
          img: logoId ? getImageUrl({ image_id: logoId }) : "/assets/ucl/match-1.webp",
          league: "UEFA Champions League",
          title: ch.name || ch.short_name || "Live Channel",
        };
      })
    : UCL_FALLBACK_MATCHES;

  return (
    <section className="ucl-section">
      <div className="ucl-section__bg">
        <img src="/assets/ucl/bg-player-1.webp" alt="" className="ucl-section__bg-img ucl-section__bg-img--1" />
        <img src="/assets/ucl/bg-player-2.webp" alt="" className="ucl-section__bg-img ucl-section__bg-img--2" />
        <img src="/assets/ucl/bg-player-3.webp" alt="" className="ucl-section__bg-img ucl-section__bg-img--3" />
        <img src="/assets/ucl/bg-player-4.webp" alt="" className="ucl-section__bg-img ucl-section__bg-img--4" />
        <div className="ucl-section__overlay" />
      </div>

      <div className="ucl-section__header">
        <img
          src="/assets/ucl/ucl-logo.svg"
          alt="UEFA Champions League"
          className="ucl-section__logo"
        />
        <p className="ucl-section__subtitle">
          Watch the world-class matches presented in the 2023 - 2024 Uefa Champions League
        </p>
      </div>

      <div className="ucl-section__matches">
        {matches.map((match, i) => (
          <div
            key={match.id || i}
            className="ucl-section__card"
            onClick={() => navigate(sportsChannels.length > 0 ? `/live/${match.id}` : `/tv-channels/${match.id}`)}
            role="button"
            tabIndex={0}
          >
            <div className="ucl-section__card-thumb">
              <img src={match.img} alt={match.title} className="ucl-section__card-img" />
              <img src="/assets/ucl/play-circle.svg" alt="Play" className="ucl-section__card-play" />
            </div>
            <div className="ucl-section__card-info">
              <span className="ucl-section__card-league">{match.league}</span>
              <h3 className="ucl-section__card-title">{match.title}</h3>
              <span className="ucl-section__card-live">
                <span className="ucl-section__card-live-dot" />
                LIVE
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UclSection;
